<template>
  <NoteList
          :delete-permission="'delete_inventoryitem'"
          :change-permission="'change_inventoryitem'"
          :object-uuid="inventory.uuid"
          plural-object-name="inventories" object-name="inventory" :is-loading-text="false"/>
</template>

<script>
  import NoteList from "./../../../notes/NotesList";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "Notes",
    components: {NoteList},
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
      }),
    },
  }
</script>

<style scoped>

</style>
